import React from 'react';
interface PlaceholderPageProps {
  title: string;
  description: string;
}
export function PlaceholderPage({
  title,
  description
}: PlaceholderPageProps) {
  return <div className="flex items-center justify-center min-h-screen bg-gray-50" data-id="element-1262">
      <div className="text-center" data-id="element-1263">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1264">{title}</h1>
        <p className="text-gray-600" data-id="element-1265">{description}</p>
      </div>
    </div>;
}